type Time = string | number;

export function msToTime(ms: number) {
    if (ms < 0) return String(ms);
    const totalSeconds = Math.floor(ms / 1000);
    let hours: Time = Math.floor(totalSeconds / 3600);
    let minutes: Time = Math.floor((totalSeconds % 3600) / 60);
    let seconds: Time = totalSeconds % 60;

    hours = String(hours).padStart(2, '0');
    minutes = String(minutes).padStart(2, '0');
    seconds = String(seconds).padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
}
